import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInformationCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.33398 8.50001C1.33398 4.81811 4.31875 1.83334 8.00065 1.83334C11.6826 1.83334 14.6673 4.81811 14.6673 8.50001C14.6673 12.1819 11.6825 15.1667 8.00065 15.1667C4.31875 15.1667 1.33398 12.1819 1.33398 8.50001ZM8.66732 6.24928C8.66732 5.88109 8.36884 5.58261 8.00065 5.58261C7.63246 5.58261 7.33398 5.88109 7.33398 6.24928V6.25003C7.33398 6.61822 7.63246 6.91669 8.00065 6.91669C8.36884 6.91669 8.66732 6.61822 8.66732 6.25003V6.24928ZM8.66732 8.50003C8.66732 8.13184 8.36884 7.83336 8.00065 7.83336C7.63246 7.83336 7.33398 8.13184 7.33398 8.50003V11.1667C7.33398 11.5349 7.63246 11.8334 8.00065 11.8334C8.36884 11.8334 8.66732 11.5349 8.66732 11.1667V8.50003Z",
		fill: "currentColor"
	})
});
export default SvgInformationCircle;
